import { StoreActionType as Type } from "../../types";

export const showSnackbar = (payload: any) => ({
  type: Type.SHOW_SNACKBAR,
  payload: payload,
});

export const hideSnackbar = () => ({
  type: Type.HIDE_SNACKBAR,
});
